<template>
  <DashboardContentLayout>TenderNetworkOpsPage</DashboardContentLayout>
</template>
